import EsfirusSelect from '@components/ui/Select/EsfirusSelect';
import EsfirusTextInput from '@components/ui/Text-input/EsfirusTextInput';
import { Grid } from '@mui/material';
import React, { useMemo } from 'react';

interface TimeInputsContainerProps {
  hours: number;
  minutes: number;
  onChange: (minutesHours: { minutes: number; hours: number }) => void;
  onBlur?: (minutesHours: { minutes: number; hours: number }) => void;
  modifiedHours: boolean;
  modifiedMinutes: boolean;
  disabled: boolean;
  untilMinute?: number;
}

const clamp = (n: number, min: number, max: number) => Math.min(max, Math.max(min, n));

const TimeInputsContainer: React.FC<TimeInputsContainerProps> = ({
  minutes,
  hours,
  onChange,
  onBlur,
  modifiedHours,
  modifiedMinutes,
  disabled,
  untilMinute = 60,
}) => {
  const minutesOptions = useMemo(() => {
    const step = clamp(Number(untilMinute) || 5, 1, 60);

    const options: Array<{ label: string; value: number }> = [];
    for (let m = 0; m < 60; m += step) {
      options.push({ label: String(m).padStart(2, '0'), value: m });
    }
    return options;
  }, [untilMinute]);

  // Si el valor actual no encaja (p.ej. cambió untilMinute), lo ajustamos al más cercano válido
  const normalizedMinutes = useMemo(() => {
    const step = clamp(Number(untilMinute) || 5, 1, 60);

    const rounded = Math.round(Number(minutes) / step) * step;
    return clamp(rounded, 0, 59);
  }, [minutes, untilMinute]);

  return (
    <>
      <Grid item xs={6} md={2}>
        <label>Horas</label>
        <EsfirusTextInput
          type="number"
          fullWidth
          value={hours}
          InputProps={{ inputProps: { min: 0 } }}
          onChange={(e: any) => onChange({ minutes: normalizedMinutes, hours: Number(e.target.value) })}
          onBlur={() => onBlur?.({ minutes: normalizedMinutes, hours })}
          modified={modifiedHours}
          disabled={disabled}
        />
      </Grid>

      <Grid item xs={6} md={2}>
        <label>Minutos</label>
        <EsfirusSelect
          options={minutesOptions}
          change={(value: string) => onChange({ hours, minutes: Number(value) })}
          blur={() => onBlur?.({ minutes: normalizedMinutes, hours })}
          value={normalizedMinutes}
          placeholder={'Minutos'}
          modified={modifiedMinutes}
          disabled={disabled}
          disableBlank
        />
      </Grid>
    </>
  );
};

export default TimeInputsContainer;
